export const component = 'mobile-general-form-base';

export const events = [
    'ready',
    'updated',
    'all-updated',
];

export const ableProps = [
    {
        key: 'hide',
        label: '是否隐藏',
        type: 'boolean',
    },
    {
        key: 'disabled',
        label: '是否禁用',
        type: 'boolean',
    },
];

export const ablePropsInit = {
    hide: false,
    disabled: false,
};

export const exampleProps = [
    {
        key: 'exampleSettings',
        label: '示例图',
        type: 'exampleSettings',
        props: {},
    },
];
export const consistenceProps = [
    {
        key: 'consistenceSettings',
        label: '一致性校验',
        type: 'consistenceSettings',
        props: {},
    },
];

export const examplePropsInit = {
    exampleSettings: '',
};
export const consistencePropsInit = {
    consistenceSettings: '',
};


export const requiredProps = [
    {
        key: 'required',
        label: '是否必须',
        type: 'boolean',
    },
    {
        key: 'errRequired',
        label: '必须提示文案',
        type: 'string',
    },
];

export const requiredPropsInit = {
    required: false,
    errRequired: '',
};


export const validatorProps = [
    {
        key: 'validator',
        label: '校验API',
        type: 'uuid-select',
        props: {
            multiple: false,
            apiOnly: true,
        },
    },
    {
        key: 'errValidator',
        label: '校验API错误文案',
        type: 'string',
    },
];

export const validatorPropsInit = {
    validator: null,
    errValidator: '',
};
